<template>
  <v-btn
    v-if="whatsappNumber"
    :href="whatsappUrl"
    target="_blank"
    rel="noopener noreferrer"
    icon
    variant="text"
    size="small"
    color="primary"
    class="whatsapp-header-button"
    aria-label="Contact us on WhatsApp"
  >
    <v-icon color="#25D366" size="22">mdi-whatsapp</v-icon>
  </v-btn>
</template>

<script setup lang="ts">
import { computed } from 'vue';

// 환경 변수에서 WhatsApp 번호 가져오기 (기본값: www.lettaga.sg의 번호)
const whatsappNumber = computed(() => {
  // 환경 변수에서 가져오기 (VITE_WHATSAPP_NUMBER)
  const envNumber = import.meta.env.VITE_WHATSAPP_NUMBER;
  if (envNumber) {
    return envNumber;
  }
  // 기본값: www.lettaga.sg에서 사용하는 번호
  return '+6587752369';
});

// WhatsApp URL 생성 (wa.me 형식)
const whatsappUrl = computed(() => {
  // wa.me는 국가코드 포함 "숫자만" 요구 — +, 공백, 하이픈 등 비숫자 전부 제거.
  // (+ 가 남아 있으면 링크 미리보기/로고가 표시되지 않음)
  const cleanNumber = whatsappNumber.value.replace(/\D/g, '');
  return `https://wa.me/${cleanNumber}`;
});
</script>

<style scoped>
.whatsapp-header-button {
  transition: transform 0.2s ease;
}

.whatsapp-header-button:hover {
  transform: scale(1.1);
}
</style>
